import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { LRErrorCode } from '../index'
import { PasswordRequirementsList } from '../modules/password-requirements-list'
import { LoginService } from '../services/login-service'
import { IdentityScreen, LoginRadiusWidget, LRWidgetType } from './base'

export class ResetPasswordWidget extends LoginRadiusWidget {
    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.RESET_PASSWORD
        this.lrObject = lrObject
        this.container = container
    }

    /**
     * Callback function used by LR widget
     * @param response any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onSuccess(response: any) {
        logger('info', response)
        LoginService.clearErrors()
        // Success page
        DOMUtils.removeClass(document.body, IdentityScreen.FORM)
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)
    }

    /**
     * Callback function used by LR widget
     * @param errors any
     *
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     */
    public onError(errors: any) {
        logger('error', errors)
        const error = (Array.isArray(errors)) ? errors[0] : undefined
        LoginService.clearErrors()

        PasswordRequirementsList.showPasswordRequirementsList()

        if (error) {
            if (error.ErrorCode === LRErrorCode.LINK_ALREADY_USED ||
                error.ErrorCode === LRErrorCode.LINK_EXPIRED ||
                error.ErrorCode === LRErrorCode.LINK_TOKEN_INVALID) {
                // Invalid and expired token page
                DOMUtils.removeClass(document.body, IdentityScreen.FORM)
                DOMUtils.addClass(document.body, IdentityScreen.ERROR)
            } else {
                LoginService.showErrors(errors)
            }
            LoginService.sendSubmissionErrorAnalytics(errors, 'reset-password')
        }
    }
}
